import React, { useState, useEffect } from 'react';
import axios from '../api/axiosConfig';
import './Modal.css';

const TramiteTypeFormModal = ({ isOpen, tramiteType, transitos, onClose, onSubmit }) => {
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    value: '',
    tarifa: '',
    transito_id: '',
    concesionario_ids: [],
  });
  const [concesionarios, setConcesionarios] = useState([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (tramiteType) {
      setFormData({
        name: tramiteType.name,
        description: tramiteType.description || '',
        value: tramiteType.value || '',
        tarifa: tramiteType.tarifa || '',
        transito_id: tramiteType.transito_id || '',
        concesionario_ids: (tramiteType.concesionario_ids || []).map(Number),
      });
    } else {
      setFormData({
        name: '',
        description: '',
        value: '',
        tarifa: '',
        transito_id: '',
        concesionario_ids: [],
      });
    }
    setError('');
  }, [tramiteType, isOpen]);

  useEffect(() => {
    if (isOpen) axios.get('/api/concesionarios').then(r => setConcesionarios(r.data || [])).catch(() => setConcesionarios([]));
  }, [isOpen]);

  const toggleConc = (id) => setFormData(prev => ({
    ...prev,
    concesionario_ids: prev.concesionario_ids.includes(id) ? prev.concesionario_ids.filter(x => x !== id) : [...prev.concesionario_ids, id]
  }));

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'value' || name === 'tarifa') {
      // Eliminar todo lo que no sea número
      const rawValue = value.replace(/\D/g, '');
      setFormData(prev => ({ ...prev, [name]: rawValue }));
    } else {
      setFormData(prev => ({ ...prev, [name]: value }));
    }
  };

  const formatInputAmount = (val) => {
    if (!val) return '';
    return new Intl.NumberFormat('es-CO').format(val);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!formData.name.trim()) {
      setError('El nombre es requerido');
      return;
    }

    if (!formData.transito_id) {
      setError('Debe seleccionar un organismo de tránsito');
      return;
    }

    if (!formData.value || formData.value <= 0) {
      setError('El valor debe ser mayor a 0');
      return;
    }

    setLoading(true);

    try {
      await onSubmit({
        name: formData.name.trim(),
        description: formData.description.trim(),
        value: parseFloat(formData.value),
        tarifa: parseFloat(formData.tarifa) || 0,
        transito_id: parseInt(formData.transito_id),
        concesionario_ids: formData.concesionario_ids,
      });
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={() => !loading && onClose()}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>{tramiteType ? '✏️ Editar Tipo' : '➕ Nuevo Tipo de Trámite'}</h2>
          <button 
            className="modal-close" 
            onClick={onClose}
            disabled={loading}
          >
            ✕
          </button>
        </div>

        <form onSubmit={handleSubmit} className="modal-form">
          {error && <div className="error-message">{error}</div>}

          <div className="form-group">
            <label htmlFor="name" style={{ fontSize: '11px', fontWeight: '800' }}>NOMBRE DEL TRÁMITE <span style={{ color: 'red' }}>*</span></label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="EJ: MATRÍCULA INICIAL"
              disabled={loading}
              style={{ textTransform: 'uppercase' }}
            />
          </div>

          <div className="form-group">
            <label htmlFor="transito_id" style={{ fontSize: '11px', fontWeight: '800' }}>ORGANISMO DE TRÁNSITO <span style={{ color: 'red' }}>*</span></label>
            <select
              id="transito_id"
              name="transito_id"
              value={formData.transito_id}
              onChange={handleChange}
              disabled={loading}
            >
              <option value="">seleccione un tránsito...</option>
              {transitos && transitos.map(t => (
                <option key={t.id} value={t.id}>{t.name}</option>
              ))}
            </select>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
            <div className="form-group">
              <label htmlFor="tarifa" style={{ fontSize: '11px', fontWeight: '800' }}>TARIFA <span style={{ color: 'red' }}>*</span></label>
              <div style={{ position: 'relative' }}>
                <span style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: '#64748b', fontWeight: 'bold' }}>$</span>
                <input
                  type="text"
                  id="tarifa"
                  name="tarifa"
                  inputMode="numeric"
                  value={formatInputAmount(formData.tarifa)}
                  onChange={handleChange}
                  placeholder="0"
                  disabled={loading}
                  style={{ paddingLeft: '25px' }}
                />
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="value" style={{ fontSize: '11px', fontWeight: '800' }}>VALOR TRÁMITE <span style={{ color: 'red' }}>*</span></label>
              <div style={{ position: 'relative' }}>
                <span style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: '#64748b', fontWeight: 'bold' }}>$</span>
                <input
                  type="text"
                  id="value"
                  name="value"
                  inputMode="numeric"
                  value={formatInputAmount(formData.value)}
                  onChange={handleChange}
                  placeholder="0"
                  disabled={loading}
                  style={{ paddingLeft: '25px' }}
                />
              </div>
            </div>
          </div>

          <div className="form-group">
            <label style={{ fontSize: '11px', fontWeight: '800' }}>CONCESIONARIOS QUE PUEDEN USAR ESTE TRÁMITE</label>
            <small style={{ display: 'block', color: '#64748b', marginBottom: '6px' }}>
              Si no marca ninguno, lo ven todos los concesionarios que tengan este tránsito. Si marca alguno, solo lo ven esos concesionarios y el superadmin.
            </small>
            <div style={{ maxHeight: '150px', overflowY: 'auto', border: '1px solid #ddd', padding: '8px', borderRadius: '4px' }}>
              {concesionarios.map(c => (
                <label key={c.id} style={{ display: 'flex', alignItems: 'center', gap: '8px', fontWeight: 'normal', margin: '0 0 6px 0', cursor: 'pointer' }}>
                  <input type="checkbox" checked={formData.concesionario_ids.includes(c.id)} onChange={() => toggleConc(c.id)} disabled={loading}
                    style={{ width: '16px', height: '16px', margin: 0 }} />
                  🏪 {c.name}
                </label>
              ))}
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="description" style={{ fontSize: '11px', fontWeight: '800' }}>DESCRIPCIÓN</label>
            <textarea
              id="description"
              name="description"
              value={formData.description}
              onChange={handleChange}
              placeholder="descripción del trámite (opcional)"
              disabled={loading}
              rows="3"
              style={{ textTransform: 'uppercase' }}
            />
          </div>

          <div className="modal-actions" style={{ marginTop: '20px' }}>
            <button
              type="button"
              className="btn btn-cancel"
              onClick={onClose}
              disabled={loading}
            >
              cancelar
            </button>
            <button
              type="submit"
              className="btn btn-save"
              disabled={loading}
              style={{ fontWeight: '800' }}
            >
              {loading ? '⏳ GUARDANDO...' : tramiteType ? '✓ ACTUALIZAR' : '✓ CREAR TIPO'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default TramiteTypeFormModal;
